module.exports = "/_next/static/images/5fae75a64ae3e10ff868e9e94c70536f-bag.svg.webp";